export const NEXO_NAMESPACE = '@@nexo/reducer/';
